<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/inventory')") Inventory
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/services')") Services
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Packages
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/stocktakes')") Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/locations')") Locations
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="Auth('root', 'subscribe_purchase_hub')" @click="$router.push('/admin/clinic/inventory-list')") List

    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Packages
        v-row.pb-2.pb-md-0(no-gutters)
          v-col(cols="12" md="6")
            v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold" @change="tabChanged(tabs)")
              v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
              v-tab.text-sm.font-medium.text-none.px-4 Active
              v-tab.text-sm.font-medium.text-none.px-4 Out of stock
              v-tab.text-sm.font-medium.text-none.px-4 Archived
          v-col(cols="12" md="6" align="end")
            .d-flex.align-center
              v-spacer
              v-btn(@click="clickSearch" icon color="neutral500")
                v-icon(size="20") $yzi-search-sm
              v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
              div
                customize-column-menu(type="package" :showTooltip="false" iconSize="21")
              y-button.ml-3(label="Add new" size="sm" @click="addNewPackage")
        v-divider

        filter-packages-row.my-2(ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
        v-skeleton-loader.mt-sm-4.pb-6(v-if="isFetching" type="table-tbody")
        .data-table(v-else)
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="packages" item-key="id" :items-per-page="pageSize" hide-default-footer :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" :server-items-length="totalCount" @update:sort-by="sortBy = $event" @update:sort-desc="sortIsDesc = $event" @click:row="editPackage")
            //- name
            template(v-slot:item.name="{ item }")
              .d-flex.align-center.justify-space-between
                .text-sm.neutral700--text {{ item.product.name }}
                yz-badge(v-if="item.product.branch_for" x-small color="blue-100" text-color="blue-500" border) HQ
            //- stock
            template(v-slot:item.stock="{ item }")
              .text-sm.text-neutral-500.font-italic(v-if="item.available_qty === false") Not applicable
              .text-sm.neutral700--text(v-else-if="item.available_qty === null") -
              .text-sm.neutral700--text(v-else-if="item.available_qty > 0") {{ item.available_qty }} in stock
              .text-sm.danger500--text(v-else-if="item.available_qty === 0") 0 in stock
              .text-sm.neutral700--text(v-else) -
            //- price
            template(v-slot:item.price="{ item }")
              .text-sm.success500--text {{ item.product.price | displayPrice($currency) }}
            //- items
            template(v-slot:item.items="{ item }")
              div.py-3(v-if="item.treatments.length")
                template(v-for="treatment in item.treatments")
                  v-row(dense)
                    v-col(cols="5")
                      .text-sm.neutral700--text {{ treatment.name }}
                    v-col(cols="2")
                      .text-sm.neutral700--text QTY: {{ treatment.quantity_per_set }} {{ getTreatmentUnit(treatment) }}
                    v-col(cols="3")
                      .text-sm.text-neutral-500.font-italic(v-if="treatment.deleted || treatment.company !== company.id") Not applicable
                      .text-sm.neutral700--text(v-else-if="treatment.inventory_enabled") {{ treatment.inventory_qty }} in stock
                      .text-sm.neutral700--text(v-else) -
                    v-col(cols="2")
                      .text-sm.neutral700--text {{ treatment.price | displayPrice($currency) }}
            //- status
            template(v-slot:item.status="{ item }")
              y-chip(v-if="item.product.status === 'published'" label="Active" color="green")
                template(#prepend)
                  v-icon.mr-1(size="12" color="success600") mdi-record
              y-chip(v-else label="Archived" color="red")
                template(#prepend)
                  v-icon.mr-1(size="12" color="danger600") mdi-record
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div(@click.stop)
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editPackage(item)")
                      v-list-item-title.text-sm.basic800--text {{ item.product.branch_for ? 'View item' : 'Edit item' }}
                    v-divider
                    v-list-item(@click="goToPackageHistory(item)")
                      v-list-item-title.text-sm.basic800--text Package history
                    template(v-if="!item.product.branch_for")
                      v-divider
                      v-list-item(@click="updateStatus(item)")
                        v-list-item-title.text-sm(:class="item.product.status === 'published' ? 'danger500--text' : 'success500--text'") {{ item.product.status === 'published' ? 'Archive' : 'Activate' }}
                      template(v-if="item.product.status === 'draft'")
                        v-divider
                        v-list-item(@click="deletePackage(item)")
                          v-list-item-title.text-sm.danger500--text Delete item

        div.fill-width
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show item" attach menu-top @input="pageChanged" @pageSizeChanged="fetchFirstPage")
  y-sorter(v-model="ordering" :headers="headers" :sort-by="sortBy" :is-desc="sortIsDesc")
  .dialogs
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Are you sure you want to delete this package?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click "Confirm" to proceed
    package-uom-warning-dialog(v-if="showUomWarningDialog" :open.sync="showUomWarningDialog" :treatments="uomWarningTreatments")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'
import FilterPackagesRow from '@/components/clinic/inventory/FilterPackagesRow.vue'
import PackageUomWarningDialog from '@/components/clinic/inventory/PackageUomWarningDialog.vue'
import YSorter from "@/components/YSorter.vue";

export default {
  name: 'Packages',
  components: {YSorter, CustomizeColumnMenu, DeleteConfirmationDialog, FilterPackagesRow, PackageUomWarningDialog },
  props: ['savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    isChecking: false,
    showSearchField: false,
    openDeleteDialog: false,
    searchText: null,
    tabs: 0,
    selectedPackage: null,
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    packages: [],
    filters: [],
    sortBy: null,
    sortIsDesc: false,
    ordering: null,
    showUomWarningDialog: false,
    uomWarningTreatments: [],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      packageFields: 'clinic/getPackageFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true, sort_query_param: 'product__name' }
      const fields = this.packageFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false,
        width: 60
      }
      return [name, ...fields, actions]
    },
  },
  watch: {
    filters () {
      if (this.isChecking) {
        this.fetchPackages()
      } else {
        this.fetchFirstPage()
      }
    },
    ordering (val) {
      this.currentPage = 1
      if (val === null || val === undefined) {
        localStorage.removeItem('yz_packages_ordering')
      } else {
        localStorage.setItem('yz_packages_ordering', val)
      }
      if (!this.isChecking) {
        this.fetchPackages()
      }
    }
  },
  mounted () {
    this.checkProps()
    this.checkOrdering()
    this.headers.map(item => item['class'] = 'text-table-header')
    if (this.saveFilters) {
      this.$refs.filter.setFilters()
    } else {
      this.fetchPackages()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    checkOrdering () {
      const savedOrdering = localStorage.getItem('yz_packages_ordering')
      if (savedOrdering) {
        this.ordering = savedOrdering
      }
    },
    fetchPackages () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ordering: this.ordering
      }
      if (this.tabs === 1) { params.status = 'published' }
      if (this.tabs === 2) { params.no_stock = true }
      if (this.tabs === 3) { params.status = 'draft' }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/clinics/${this.company.slug}/packages`, { params })
        .then(resp => {
          this.packages = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchPackages()
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchPackages()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    checkProps () {
      this.isChecking = true
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
      if (this.saveTab) {
        this.tabs = this.saveTab
      }
      setTimeout(() => {
        this.isChecking = false
      }, 2000)
    },
    addNewPackage () {
      this.$router.push('/admin/clinic/package')
    },
    editPackage (item) {
      let params = {
        id: item.id,
        savePage: this.currentPage,
        saveTab: this.tabs,
        saveSearch: this.searchText,
        saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
      }
      this.$router.push({ name: 'EditClinicPackage', params })
    },
    goToPackageHistory (item) {
      this.$router.push({ name: 'PackageHistory', params: { id: item.id, origin: 'ClinicPackages' } })
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    updateStatus (item) {
      if (item.product.status === 'draft') {
        const invalidTreatments = this.getInvalidUomTreatments(item.treatments || [])
        if (invalidTreatments.length) {
          this.uomWarningTreatments = invalidTreatments
          this.showUomWarningDialog = true
          return
        }
      }
      this.isFetching = true
      let data = {
        product: {
          status: item.product.status === 'published' ? 'draft' : 'published'
        }
      }
      this.$axios.patch(`/clinics/${this.company.slug}/packages/${item.id}`, data)
        .then(() => {
          this.fetchPackages()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    confirmDelete () {
      this.isLoading = true
      this.$axios.delete(`/clinics/${this.company.slug}/packages/${this.selectedPackage.id}`)
        .then(() => {
          this.reset()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deletePackage (item) {
      this.selectedPackage = item
      this.openDeleteDialog = true
    },
    reset () {
      this.fetchFirstPage()
      this.closed()
    },
    closed () {
      this.selectedPackage = null
      this.openDeleteDialog = false
    },
    getTreatmentUnit (treatment) {
      if (treatment.uom_conversion_enabled && treatment.uom_conversions && treatment.uom_conversions.length) {
        return treatment.uom_conversions[treatment.uom_conversions.length - 1].convert_to || ''
      }
      return (treatment.per_set && treatment.per_set.uom) || ''
    },
    getInvalidUomTreatments (treatments) {
      const invalid = []
      treatments.forEach(t => {
        if (!t.uom_conversion_enabled || !t.uom_conversions || !t.uom_conversions.length) return
        const validUnits = []
        t.uom_conversions.forEach(c => {
          if (c.uom && !validUnits.includes(c.uom)) validUnits.push(c.uom)
          if (c.convert_to && !validUnits.includes(c.convert_to)) validUnits.push(c.convert_to)
        })
        const currentUom = (t.per_set && t.per_set.uom) || t.uom || null
        if (!currentUom || !validUnits.includes(currentUom)) {
          invalid.push({ name: t.name, currentUom: currentUom || '—', availableUoms: validUnits.join(', ') })
        }
      })
      return invalid
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.packages.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>